<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-06 17:50:27
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-14 20:04:21
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/component-wnfw.vue
 * @Description: 为农服务
-->
<template>
  <div class="wnfw">
    <div class="content">
      <!-- 统计 -->
      <div class="tj" v-loading="loading.wnfw">
        <template v-if="!loading.wnfw">
          <section
            class="lb"
            v-for="(item, index) in wnfw.statistics_data"
            :key="index"
          >
            <i class="icon" />
            <span class="name" v-text="item.name"></span>
            <span class="value">
              <span v-if="item.value === 0">{{ item.value }}</span>
              <ICountUp v-else :endVal="Number(item.value)" />
              <span class="unit" v-text="item.unit"></span>
            </span>
          </section>
        </template>
      </div>
      <!-- 课程 -->
      <div class="kc" v-loading="loading.wnfw">
        <template v-if="!loading.wnfw">
          <loading-bar :data="wnfw.course_data" />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('company-profile', ['loading', 'wnfw'])
  },
  methods: {
    ...mapActions('company-profile', ['getWNFW'])
  },
  created () {
    this.getWNFW()
  }
}
</script>

<style lang="scss">
.wnfw {
  padding-top: 52px;
  .content {
    height: 100%;
    position: relative;
    .tj {
      display: flex;
      flex-direction: row;
      height: 132px;
      width: 343px;
      margin: 0 auto;
      margin-top: 30px;
      .lb {
        flex: 1;
        height: 100%;
        position: relative;
        .icon {
          display: block;
          width: 102px;
          height: 116px;
          position: absolute;
          bottom: 0;
          left: calc((100% - 102px) / 2);
          &:nth-of-type(0) {
            background-image: url("/public/image/company-profile/icon/培训@2x.png");
          }
          &:nth-of-type(1) {
            background-image: url("/public/image/company-profile/icon/分析@2x.png");
          }
          &:nth-of-type(2) {
            background-image: url("/public/image/company-profile/icon/农药@2x.png");
          }
        }
        .name {
          position: absolute;
          left: 0;
          width: 100%;
          bottom: 72px;
          text-align: center;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
        .value {
          position: absolute;
          left: 0;
          width: 100%;
          top: 0;
          text-align: center;
          font-size: 24px;
          font-family: Montserrat;
          font-weight: 400;
          color: #10f5b1;
          .unit {
            font-size: 14px;
          }
        }
      }
    }
    .kc {
      height: 204px;
      width: 343px;
      margin: 0 auto;
      margin-top: 50px;
    }
  }
}
</style>
